import { FeatureFlags } from '../../data-types/feature-flags/featureFlagsInterfaces';
import { CountrySettings, InternationalSettings } from '../../data-types/international/internationalInterfaces';
import { WalletSettings } from '../../data-types/wallet/walletInterfaces';
import { ResetState } from './stateTypes';

export type CustomizationActionType =
  | ResetState
  | SetFeatureFlags
  | SetMoodBarScore
  | SetCasinoFirstFlag
  | SetMaintenance
  | SetBetkwiffDomainFlag
  | SetWalletSettings
  | SetAllAvailableCountrySettings
  | SetCountrySettingsByLocation
  | SetCanPlayCasino
  | SetNetPromoterScoreFlag
  | SetCanShowAviator
  | SetReorderCasinoFilters
  | SetBetPlacementRocketAnimation;

export const SET_CASINO_FIRST_FLAG = 'SET_CASINO_FIRST_FLAG';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const SET_MOODBAR_SCORE = 'SET_MOODBAR_SCORE';
export const SET_WALLET_SETTINGS = 'SET_WALLET_SETTINGS';
export const SET_MAINTENANCE = 'SET_MAINTENANCE';
export const SET_BETKWIFF_DOMAIN_FLAG = 'SET_BETKWIFF_DOMAIN_FLAG';
export const SET_ALL_AVAILABLE_COUNTRY_SETTINGS = 'SET_ALL_AVAILABLE_COUNTRY_SETTINGS';
export const SET_COUNTRY_SETTINGS_BY_LOCATION = 'SET_COUNTRY_SETTINGS_BY_LOCATION';
export const SET_CAN_PLAY_CASINO = 'SET_CAN_PLAY_CASINO';
export const SET_NET_PROMOTER_SCORE_FLAG = 'SET_NET_PROMOTER_SCORE_FLAG';
export const SET_CAN_SHOW_AVIATOR = 'SET_CAN_SHOW_AVIATOR';
export const SET_REORDER_CASINO_FILTERS = 'SET_REORDER_CASINO_FILTERS';
export const SET_BET_PLACEMENT_ROCKET_ANIMATION = 'SET_BET_PLACEMENT_ROCKET_ANIMATION';

export interface CustomizationState {
  isCasinoFirst: boolean;
  featureFlags: FeatureFlags;
  moodBarScore: number;
  maintenance: boolean;
  internationalSettings: InternationalSettings;
  netPromoterScoreFlag: boolean;
  reorderCasinoFilters: boolean;
  betPlacementRocketAnimation: boolean;
}

interface SetCasinoFirstFlag {
  type: typeof SET_CASINO_FIRST_FLAG;
  meta: boolean;
}

interface SetFeatureFlags {
  type: typeof SET_FEATURE_FLAGS;
  meta: FeatureFlags;
}

interface SetMaintenance {
  type: typeof SET_MAINTENANCE;
  meta: boolean;
}

interface SetMoodBarScore {
  type: typeof SET_MOODBAR_SCORE;
  meta: number;
}

interface SetBetkwiffDomainFlag {
  type: typeof SET_BETKWIFF_DOMAIN_FLAG;
  meta: boolean;
}

interface SetAllAvailableCountrySettings {
  type: typeof SET_ALL_AVAILABLE_COUNTRY_SETTINGS;
  meta: CountrySettings[];
}

interface SetCountrySettingsByLocation {
  type: typeof SET_COUNTRY_SETTINGS_BY_LOCATION;
  meta: CountrySettings | undefined;
}

interface SetCanPlayCasino {
  type: typeof SET_CAN_PLAY_CASINO;
  meta: boolean;
}

interface SetWalletSettings {
  type: typeof SET_WALLET_SETTINGS;
  meta: WalletSettings;
}

interface SetNetPromoterScoreFlag {
  type: typeof SET_NET_PROMOTER_SCORE_FLAG;
  meta: boolean;
}

interface SetCanShowAviator {
  type: typeof SET_CAN_SHOW_AVIATOR;
  meta: boolean;
}

interface SetReorderCasinoFilters {
  type: typeof SET_REORDER_CASINO_FILTERS;
  meta: boolean;
}

interface SetBetPlacementRocketAnimation {
  type: typeof SET_BET_PLACEMENT_ROCKET_ANIMATION;
  meta: boolean;
}
